import { Navigate } from "react-router-dom";
import { CREATIVE_VARIANTS } from "./SharedCreative";

const CreativeRandomizer: React.FC = () => {
  const randomIndex = Math.floor(Math.random() * CREATIVE_VARIANTS.length);
  return <Navigate to={CREATIVE_VARIANTS[randomIndex]} replace />;
};

export default CreativeRandomizer;
